import { axiosApiInstance } from './axios';

const apiRoot = '';

const taxesApi = {
  get: async (scope?: 'all' | 'current') => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/taxes`, {
        params: scope && scope !== 'current' ? { scope } : undefined,
      });
      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  create: async (data) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/taxes`, data);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getSingle: async (id) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/taxes/${id}`);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  edit: async (id, data) => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/taxes/${id}`, data);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  remove: async (id) => {
    try {
      const res = await axiosApiInstance.delete(`${apiRoot}/taxes/${id}`);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default taxesApi;
